@if (this.usuarios$ | async; as usuarios ) {
    <div>
        <button mat-icon-button [matMenuTriggerFor]="menu">

            <mat-icon
                [svgIcon]="'heroicons_outline:user-plus'">
            </mat-icon>
            
        </button>
    
        <mat-menu #menu="matMenu">
            @for (usuario of usuarios; track $index){
                <button mat-menu-item (click)="selecccionarUsuario(usuario)"  *ngIf="usuario.rol.tipologiaId != idUsuariosAdministradores"
                    class="h-6">
                    <mat-icon [svgIcon]="'heroicons_solid:user'"></mat-icon>
                    <span>{{usuario.nombreCompleto | titlecase }} - 
                        <span class="text-sm text-gray-400"> ({{usuario.seccion.descripcion}})</span>
                    </span>
                </button>
            }
        </mat-menu>
    </div>    
}
